import api from "./api";

export const authService = {
  getProfile: async () => {
    const response = await api.get("/auth/profile");
    return response.data;
  },

  logout: async () => {
    const response = await api.post("/auth/logout");
    return response.data;
  },

  googleLogin: () => {
    const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5002/api";
    // Redirect to backend OAuth start endpoint
    window.location.href = `${apiUrl.replace(/\/$/, "")}/auth/google`;
  },
};
